const topGallerySlide = (() => {

  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {

    const jsSecIntro = document.getElementById('jsSecIntro');
    const gallerySwiper = jsSecIntro.querySelector('.js-gallery-swiper');
    const pagination = jsSecIntro.querySelector('.js-swiper-pagination');

    const swiper = new Swiper(gallerySwiper, {
      slidesPerView: 1,
      effect: 'fade',
      speed: 1500,
      loop: false,
      autoplay: false,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        // stopOnLastSlide: 'false',
      },
      // ページネーション
      pagination: {
        el: pagination,
        clickable: true,
      },
    });

  }

})();
export default topGallerySlide;